import Icon from '../components/Icon.vue'

Icon.register({
  'laugh-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM268.1 206.1c-1.7 11.2 11.5 18.3 19.9 10.9l9.6-8.6c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.4 7.5 21.5 0.3 19.8-10.8-4-25.2-34.2-42.1-59.9-42.1s-55.9 16.9-59.9 42.1zM168 160c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM398.9 306c1.2-9.6-6.3-18-15.9-18h-270c-9.6 0-17.1 8.5-15.9 18 8.9 71 69.5 126 142.9 126h16c73.4 0 134-55 142.9-126z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laugh-wink.js
// module id = 1512
// module chunks = 0